import React from "react";
import { IBenefitResult } from "../../../../common/interfaces/IBenefitResult";
import { IClient } from "../../../../common/interfaces/IClient";
import { QuoteSettingContainerType } from "../../../../common/interfaces/settings/QuoteSettingContainerType";
import QuoteBreakdownSummary from "../../../../common/components/QuoteBreakdown/QuoteBreakdownSummary/QuoteBreakdownSummary";
import Button from "../../../../common/components/Forms/Button/Button";
import LModal from "../../../../common/components/Modals/LModal/LModal";
import ModalHeader from "../../../../common/components/Modals/ModalHeader/ModalHeader";
import styles from "./ApplyModal.module.scss";
import cx from "classnames";

interface IApplyModal {
    isOpen: boolean;
    onClose: () => void;
    // ----
    providerId: number;
    clients: IClient[];
    settings: QuoteSettingContainerType[];
    benefits: IBenefitResult[];
    url: string;
    handleClickStart: () => void;
}

const ApplyModal: React.FC<IApplyModal> = ({
    isOpen,
    onClose,
    providerId,
    clients,
    settings,
    benefits,
    url,
    handleClickStart
}) => {
    return (
        <LModal
            isOpen={isOpen}
            calcHeightMode="auto"
            Header={() => {
                return (
                    <ModalHeader onClose={onClose}>Check details and apply</ModalHeader>
                );
            }}
            onClose={onClose}
            width="wide"
            removePadding>
            {() => {
                return (
                    <QuoteBreakdownSummary
                        providerId={providerId}
                        clients={clients}
                        className={cx(styles["container"], "gap-m")}
                        settings={settings}
                        benefits={benefits}
                        isCard>
                        <Button
                            component="a"
                            onClick={handleClickStart}
                            variant="calltoaction"
                            href={url}
                            target="_blank"
                            dataAttributes={{
                                "data-ga_action": "looks-good",
                                "data-ga_label": "click",
                                "data-ga_category": "quote-form"
                            }}>
                            Apply Online
                        </Button>
                    </QuoteBreakdownSummary>
                );
            }}
        </LModal>
    );
};

export default ApplyModal;
